import { h, Component, Prop, Element } from '@stencil/core';

@Component({
  shadow: true,
  styleUrls: {
    default: 'igws-cta.less',
    rtl: 'igws-cta.rtl.less',
    rebrand: './rebrand/igws-cta.less',
    rtl_rebrand: './rebrand/igws-cta.rtl.less',
    prime: './prime/igws-cta.less',
    rtl_prime: './prime/igws-cta.rtl.less',
    investments: 'igws-cta.less',
    rtl_investments: 'igws-cta.rtl.less',
    helpandsupport: 'igws-cta.less',
    rtl_helpandsupport: 'igws-cta.rtl.less',
    academy: 'igws-cta.less',
    rtl_academy: 'igws-cta.rtl.less',
    landingpages: 'igws-cta.less',
    rtl_landingpages: 'igws-cta.rtl.less',
    generic: 'igws-cta.less',
    rtl_generic: 'igws-cta.rtl.less',
  },
  tag: 'igws-cta',
})
export class CallToActionComponent {
  @Element() el!: HTMLIgwsCtaElement;

  /**
   * Cta alignment
   */
  @Prop() align: string = '';

  /**
   * Cta type
   */
  @Prop() type: string = '';

  /**
   * Cta extra classes
   */
  @Prop() classnames: string = '';

  /**
   * Cta href
   */
  @Prop() href: string = '';

  /**
   * Cta target
   */
  @Prop() target: string = '';

  /**
   * Cta text
   */
  @Prop() text: string = '';

  /**
   * Cta iconPrefix
   */
  @Prop() iconPrefix: string = '';

  /**
   * Cta iconSuffix
   */
  @Prop() iconSuffix: string = '';

  /**
   * Cta no follow
   */
  @Prop() nofollow: boolean = false;

  /**
   * Cta ariaLabel
   */
  @Prop() labelAria: string = '';

  componentWillLoad() {
    const crawlLink = this.el && this.el.querySelector('.crawl-link');
    if (crawlLink) {
      this.el.removeChild(crawlLink);
    }
  }

  private handleNavigation = (e: MouseEvent) => {
    e.preventDefault();
    if (this.href !== '') {
      window.open(this.href, this.target || '_self');
    }
  };

  render() {
    const rel: string = this.nofollow ? 'nofollow' : '';

    return (
      <span class={`cta-wrapper ${this.align} ${this.type} ${this.classnames}`} onClick={this.handleNavigation}>
        {this.iconPrefix !== '' ? (
          <div class="prefix-wrapper">
            <img class="prefix" src={this.iconPrefix} alt="icon prefix" />
          </div>
        ) : (
          ''
        )}

        {this.text !== '' ? (
          <a
            class={`cta-anchor ${this.type}`}
            href={this.href}
            target={this.target}
            rel={rel}
            {...(this.labelAria !== '' ? { 'aria-label': this.labelAria } : {})}
          >
            <span class="cta__text" innerHTML={this.text}></span>
          </a>
        ) : (
          ''
        )}

        {this.iconSuffix !== '' ? (
          <div class="suffix-wrapper">
            <img class="suffix" src={this.iconSuffix} alt="icon suffix" />
          </div>
        ) : (
          ''
        )}
      </span>
    );
  }
}
